import {
  takeLatest, call, put, all,
} from 'redux-saga/effects';
import ProfileService from '@services/profile';
import * as actions from '@actions/profile';
import Profile from '@rootCommon/types/profile';
import { ChangePassword } from '@rootCommon/types/password';

import { AxiosError } from 'axios';
import { SagaGenerator } from './index';

// fetch profile data
function* fetchProfileAsync() {
  try {
    const profile: Profile = yield call(ProfileService.get);

    yield put(actions.fetchProfile.success(profile));
  } catch (e) {
    const error = e as AxiosError | Error;
    yield put(actions.fetchProfile.failure(error));
  }
}

function* watchFetchProfile() {
  yield takeLatest(actions.fetchProfile.request, fetchProfileAsync);
}

// update profile data
function* updateProfileAsync(action: { payload: Profile }) {
  try {
    yield call(ProfileService.update, action.payload);
    yield put(actions.updateProfile.success(action.payload));
  } catch (e) {
    const error = e as AxiosError | Error;
    yield put(actions.updateProfile.failure(error));
  }
}

function* watchUpdateProfile() {
  yield takeLatest(actions.updateProfile.request, updateProfileAsync);
}

// change profile password
function* changeProfilePasswordAsync(action: { payload: ChangePassword }) {
  try {
    yield call(ProfileService.changePassword, action.payload);
    yield put(actions.changeProfilePassword.success());
  } catch (e) {
    const error = e as AxiosError | Error;
    yield put(actions.changeProfilePassword.failure(error));
  }
}

function* watchChangeProfilePassword() {
  yield takeLatest(actions.changeProfilePassword.request, changeProfilePasswordAsync);
}

// all
export function* watchProfile(): SagaGenerator {
  yield all([watchFetchProfile(), watchUpdateProfile(), watchChangeProfilePassword()]);
}

export default watchProfile;
